import image from "../assets/205644.jpg";

const ProductList = [
  {
    id: 1,
    commodity_name: "Hair Piece",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 2,
    commodity_name: "Hair Band",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 3,
    commodity_name: "Fenty Makeup Kit",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 4,
    commodity_name: "Styling Gel",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 5,
    commodity_name: "Hair Comb",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 6,
    commodity_name: "Hair dryer",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 7,
    commodity_name: "Head & Shoulders",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "makeup",
    number_in_stock: 50,
  },
  {
    id: 8,
    commodity_name: "Electric Razor",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 9,
    commodity_name: "Miadi Hair Oil",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
  {
    id: 10,
    commodity_name: "Nail Polish Remover",
    commodity_main_image: `${image}`,
    commodity_extra_image1: `${image}`,
    commodity_extra_image2: `${image}`,
    description: "this is a product",
    price: 500,
    pricing_unit: "Kilograms",
    category: "hair care",
    number_in_stock: 50,
  },
];
export default ProductList;
